var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSearchGrey({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.14566 2.94856C5.72337 2.94856 2.94905 5.72288 2.94905 9.14517C2.94905 12.5675 5.72337 15.3418 9.14566 15.3418C10.8191 15.3418 12.3375 14.6785 13.4525 13.6004C13.4725 13.5726 13.4951 13.546 13.5201 13.5209C13.5452 13.4958 13.5719 13.4732 13.5998 13.4532C14.6785 12.3381 15.3423 10.8191 15.3423 9.14517C15.3423 5.72288 12.568 2.94856 9.14566 2.94856ZM14.8672 13.9615C15.9637 12.6603 16.6243 10.9799 16.6243 9.14517C16.6243 5.01482 13.276 1.6665 9.14566 1.6665C5.01531 1.6665 1.66699 5.01482 1.66699 9.14517C1.66699 13.2755 5.01531 16.6238 9.14566 16.6238C10.9797 16.6238 12.6596 15.9636 13.9606 14.8679L17.2381 18.1454C17.4884 18.3958 17.8943 18.3958 18.1447 18.1454C18.395 17.8951 18.395 17.4892 18.1447 17.2389L14.8672 13.9615Z",
    fill: "#4B4F5D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearchGrey);
export default __webpack_public_path__ + "static/media/search-grey.9a875b1d64cd00e9298307f40e5c9bd9.svg";
export { ForwardRef as ReactComponent };